import { useState } from 'react'
import { mdiContentCopy } from '@mdi/js'

import { CopyCodeWrapper, CopyCodeIcon, CopyCodeButton, Code } from './styles'

interface CopyCodeProps {
  code: string
}

function CopyCode({ code }: CopyCodeProps) {
  const [copied, setCopied] = useState(false)

  const handleClick = async () => {
    await navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  /**
   * @todo localization
   */

  return (
    <CopyCodeWrapper>
      <Code>{copied ? 'Copied!' : code}</Code>
      <CopyCodeButton onClick={handleClick}>
        <CopyCodeIcon path={mdiContentCopy} />
      </CopyCodeButton>
    </CopyCodeWrapper>
  )
}

export default CopyCode
